document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.our-formulas.container').forEach(section => {
    const scroller = section.querySelector('.our-formulas-slides-block');
    const prev = section.querySelector('.our-formulas-btn.prev');
    const next = section.querySelector('.our-formulas-btn.next');
    if (!scroller || !prev || !next) return;
    // Ensure horizontal scroll behavior works if CSS isn't set
    try {
      scroller.style.scrollBehavior = scroller.style.scrollBehavior || 'smooth';
      scroller.style.overflowX = scroller.style.overflowX || 'auto';
    } catch(e) {}
    function getScrollAmount() {
      const first = scroller.querySelector('.our-formulas-slide-block');
      if (first) {
        const rect = first.getBoundingClientRect();
        const style = window.getComputedStyle(first);
        const marginRight = parseFloat(style.marginRight || '0');
        return Math.ceil(rect.width + marginRight) || 300;
      }
      return 300;
    }
    function atStart() {
      // Account for the left spacer (::before) by using the first slide's offsetLeft
      const first = scroller.querySelector('.our-formulas-slide-block');
      const threshold = first ? Math.max(0, Math.round(first.offsetLeft) - 1) : 0;
      return Math.round(scroller.scrollLeft) <= threshold;
    }
    function atEnd() {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth - 1;
      return Math.ceil(scroller.scrollLeft) >= maxScroll;
    }
    function updateButtons() {
      const start = atStart();
      const end = atEnd();
      prev.disabled = start;
      next.disabled = end;
      // Toggle container classes for CSS-driven visibility
      section.classList.toggle('can-scroll-prev', !start);
      section.classList.toggle('can-scroll-next', !end);
      // Explicitly control visibility to override any inline display from markup
      prev.style.display = start ? 'none' : '';
      next.style.display = end ? 'none' : '';
    }
    prev.addEventListener('click', () => {
      const amount = getScrollAmount();
      const target = Math.max(0, scroller.scrollLeft - amount);
      scroller.scrollTo({ left: target, behavior: 'smooth' });
      // update after scroll settles
      setTimeout(updateButtons, 350);
    });
    next.addEventListener('click', () => {
      scroller.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      setTimeout(updateButtons, 350);
    });
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    // Initial state
    try { prev.disabled = true; } catch(e) {}
    updateButtons();
    // Defer once more after layout/images
    requestAnimationFrame(updateButtons);
    window.addEventListener('load', updateButtons);
  });

	// Desktop slide-in animation for the desktop carousel block
	// Only applies for screens >= 1440px, triggers when section is ~90% visible
	const desktopSection = document.querySelector('.our-formulas.container');
	if (desktopSection && window.innerWidth >= 1440) {
		const desktopBlock = desktopSection.querySelector('.our-formulas-slides-block-desktop');
		const rightCol = desktopSection.querySelector('.our-formulas-right');
		if (desktopBlock) {
			// Initial hidden state for staggered child slides
			try {
				// Confine any horizontal overflow to this section to avoid page scroll
				if (desktopSection) {
					desktopSection.style.overflowX = desktopSection.style.overflowX || 'clip';
					if (desktopSection.style.overflowX !== 'clip') {
						desktopSection.style.overflowX = 'hidden';
					}
				}
				if (rightCol) {
					rightCol.style.overflow = 'visible';
					rightCol.style.position = rightCol.style.position || 'relative';
				}
				desktopBlock.style.position = desktopBlock.style.position || 'relative';
			} catch (e) {}

			const slides = Array.from(desktopBlock.querySelectorAll('.our-formulas-slide-block'));
			if (!slides.length) return;

			function setInitialSlideState() {
				slides.forEach((slide) => {
					const rect = slide.getBoundingClientRect();
					const offscreenPx = Math.max((window.innerWidth - rect.left) + 40, 40);
					slide.style.transform = 'translateX(' + offscreenPx + 'px)';
					slide.style.transition = 'transform 1.4s cubic-bezier(0.22, 1, 0.36, 1)';
					slide.style.willChange = 'transform';
				});
			}

			setInitialSlideState();

			function startStaggeredSlides() {
				const baseDelay = 0;
				const stepDelay = 350; // slower delay between slides
				slides.forEach((slide, idx) => {
					setTimeout(() => {
						slide.style.transform = 'translateX(0)';
					}, baseDelay + idx * stepDelay);
				});
				// cleanup will-change after last slide finishes
				const last = slides[slides.length - 1];
				const onEnd = () => {
					slides.forEach(s => { try { s.style.willChange = ''; } catch(e) {} });
					try { last.removeEventListener('transitionend', onEnd); } catch(e) {}
				};
				try { last.addEventListener('transitionend', onEnd); } catch(e) {}
			}

			if ('IntersectionObserver' in window) {
				let started = false;
				const io = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (!started && entry.isIntersecting && entry.intersectionRatio >= 0.9) {
							started = true;
							startStaggeredSlides();
							io.disconnect();
						}
					});
				}, { threshold: [0, 0.5, 0.9, 1] });
				io.observe(desktopSection);
			} else {
				// Fallback: start after a short delay
				setTimeout(startStaggeredSlides, 400);
			}

			// Recompute off-screen offsets if resized before animation starts
			let animationStarted = false;
			const markStarted = () => { animationStarted = true; window.removeEventListener('transitionstart', markStarted, true); };
			try { window.addEventListener('transitionstart', markStarted, true); } catch(e) {}
			const onResize = () => {
				if (animationStarted) return;
				if (window.innerWidth < 1440) return;
				setInitialSlideState();
			};
			window.addEventListener('resize', onResize);
		}
	}
});



